import type {
  CampusFilterOption,
  StudentAccountStatus,
  StudentDetail,
  StudentListItem,
  StudentListParams,
  StudentListResult,
} from '@/types/student.types';

import { apiClient } from './api.service';

/**
 * Drops `undefined` values so axios doesn't serialize them as the string "undefined".
 */
const cleanParams = <T extends Record<string, unknown>>(input: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === '' || value === null) continue;
    out[key] = value;
  }
  return out as Partial<T>;
};

export const studentsApi = {
  list: (params: StudentListParams = {}) =>
    apiClient
      .get<StudentListResult>('/admin/users', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  listCampusOptions: () =>
    apiClient.get<CampusFilterOption[]>('/admin/users/campuses').then((r) => r.data),

  getById: (id: string) =>
    apiClient.get<StudentDetail>(`/admin/users/${id}`).then((r) => r.data),

  updateAccountStatus: (id: string, accountStatus: StudentAccountStatus) =>
    apiClient
      .patch<StudentListItem>(`/admin/users/${id}/status`, { accountStatus })
      .then((r) => r.data),

  verifyKyc: (id: string) =>
    apiClient.post<StudentListItem>(`/admin/users/${id}/verify-kyc`).then((r) => r.data),
};
